import { Role } from "../types/Role";

export function getUserRoleText(role: Role): string {
  if (role.name === "ROLE_ADMIN") {
    return "Admin";
  } else if (role.name === "ROLE_COORDINATOR") {
    return "Coordinator";
  } else {
    return "Basic";
  }
}
